// extracted by mini-css-extract-plugin
module.exports = {"component":"json-input-component--3l_NG"};